<template>
  <div class="table-header-container">
    <div class="header-container">
      <div class="header">
        Filters
      </div>
      <CycleSystemFilter />
    </div>
    <div class="filters">
      <ExportCSVButton
        v-if="activeTab === 'cycle' && cycleViewTab === 'chart'"
      />
      <ViewTab v-if="activeTab !== 'deltaT'" />
    </div>
  </div>
</template>

<script>
import CycleSystemFilter from '@shared/components/customerDetail/CycleSystemFilter.vue';
import ViewTab from '@shared/components/customerDetail/ViewTab.vue';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ExportCSVButton from '@shared/components/customerDetail/ExportCSVButton.vue';

export default {
  name: 'CycleTableFilter',
  components: {
    CycleSystemFilter,
    ExportCSVButton,
    ViewTab,
  },
  mixins: [customerDetailMixin],
};
</script>

<style lang="scss">
.table-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
  width: 100%;
  max-width: 1705px;
  .header-container {
    display: flex;
    align-items: center;
    .header {
      margin-right: 12px;
    }
  }
  .filters {
    display: flex;
  }
}
</style>
